jQuery(function($) {

    // Input
    var txtLocalita = $("[name='localita']");

    // Click sul submit della form: lancio la ricerca
    $(document).on("click", "#filtri input", function(e) {
        //e.preventDefault();
        loadFotos();
    }); 

    // Click sui link di paginazione
    $(document).on("click", ".page-foto [data-destpag]", function(e) {
        e.preventDefault();
        loadFotos($(this).attr("data-destpag"));
    });

    // Vado a comandare la ricerca AJAX
    function loadFotos(paged) {
        var paged = typeof paged !== "undefined" ? paged: 1;

        var data = {
            // fotoSubmit va usato negli add_action in functions.php, nella forma:
            // wp_ajax_fotoSubmit
            // wp_ajax_nopriv_fotoSubmit
            action: "fotoSubmit",
            paged: paged,
            ambiente: [],
            stile: [],
            colore: [],
            contesto: [],
        };

        // Popolo i filtri inizializzati sopra
        $("#filtri .filtro-ambiente input:checked").each(function() {
            data['ambiente'].push($(this).val());
        }),
        $("#filtri .filtro-stile input:checked").each(function() {
            data['stile'].push($(this).val());
        }),
        $("#filtri .filtro-colore input:checked").each(function() {
            data['colore'].push($(this).val());
        }),
        $("#filtri .filtro-contesto input:checked").each(function() {
            data['contesto'].push($(this).val());
        }),

        //console.log(data);

        // AjaxURL e ajax_url sono i parametri che uso nella wp_localize_script del main_js (lib/assets.php)
        $.post(AjaxURL.ajax_url, data, function(response) {
            $("#foto_results_container").html(response);

            // Preso da main.js per attivare gli accordion dei filtri
            //Accordion
            var title = document.querySelectorAll('.accordion__header');
            for(var i = 0; i < title.length; i++) {
                title[i].classList.add('js-header');
                //console.log(title[i].classList);
            }
            var copy = document.querySelectorAll('.accordion__content');
            for(var i = 0; i < copy.length; i++) {
                copy[i].classList.add('js-content');
                //console.log(copy[i].classList);
            }
            $('.accordion .js-content').slideDown();
            var $title = $('.accordion .js-header');
            $title.click(function () {
                $(this).next(copy).slideToggle();
                //$(this).parent().siblings().children().next().slideUp();
                $(this).toggleClass('active');
                //$(this).parent().siblings().children().removeClass('active');
                return false;
            });
            // END Preso da main.js

            // Preso da main.js per attivare lo slider lightbox
            // gallery grande pagina foto mansarde
            $('.sfoglia').slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: true,
                lazyLoad: 'progressive'
            });

            /*
            $('.thumbnails article a').on('click',function(e){
                e.preventDefault();
                $('.sfoglia').slick('slickGoTo',$('.thumbnails article a').index(this),true);
                $('.big').addClass('openThumb');
            });

            $('.big .close').on('click',function(){
                $('.big').removeClass('openThumb');
            });
            */
            // END Preso da main.js

        });     
    }

    // Caricamento AJAX delle altre slide
    $(document).on('afterChange', '.sfoglia', function(e, slick, currentSlide) {
        var lastSlideIndex = parseInt(jQuery('.sfoglia .slick-slide:not(.slick-cloned)').length) - 1;
        $("#ajax_slides_prev_index").attr("data-index", lastSlideIndex);
        if (currentSlide == lastSlideIndex) {
            $("#ajax_slides_next_index").attr("data-index", currentSlide);
            loadFotoSlides("next");
        }
    });
    $(document).on('click', '.slick-prev', function(e) {
        var currentSlide = $('.sfoglia').slick('slickCurrentSlide');
        if (currentSlide == 0) {
            $("#ajax_slides_next_index").attr("data-index", currentSlide);
            loadFotoSlides("prev");
        }
    });
    function loadFotoSlides(direction) {
        var pageAdd = direction == "next" ? 1 : -1; 

        var pagedCounter = $("#ajax_slides_paged");
        var paged = parseInt(pagedCounter.attr("data-paged")) + pageAdd;

        if (paged < 1) return;

        var data = {
            action: "fotoLoadSlides",
            paged: paged,
            ambiente: [],
            stile: [],
            colore: [],
            contesto: [],
        };

        // Popolo i filtri inizializzati sopra
        $("#filtri .filtro-ambiente input:checked").each(function() {
            data['ambiente'].push($(this).val());
        }),
        $("#filtri .filtro-stile input:checked").each(function() {
            data['stile'].push($(this).val());
        }),
        $("#filtri .filtro-colore input:checked").each(function() {
            data['colore'].push($(this).val());
        }),
        $("#filtri .filtro-contesto input:checked").each(function() {
            data['contesto'].push($(this).val());
        }),

        //console.log(data);

        // AjaxURL e ajax_url sono i parametri che uso nella wp_localize_script del main_js (lib/assets.php)
        $.post(AjaxURL.ajax_url, data, function(response) {
            if (typeof response !== "undefined" && response !== "") {
                $('.sfoglia').slick('unslick');

                if (direction == "next") {
                    $('.sfoglia').append(response);
                }
                else {
                    $('.sfoglia').prepend(response);
                }

                $('.sfoglia').slick({
                    infinite: false,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: true,
                    lazyLoad: 'ondemand',
                });

                $('.sfoglia').slick('slickGoTo', parseInt($("#ajax_slides_"+direction+"_index").attr("data-index")), true);

                pagedCounter.attr("data-paged", paged);
            }
        });     
    }
});
